<dt-hierarchy [tree]="tree" (action)="executeAction($event)">
  <ng-template #node let-element let-loc="locationSequence" let-focused="focused">
    <div
      class="node"
      [class.root]="loc.isRoot()"
      [class.fundamental]="loc.value.length === 1"
      [class.invalid]="!element.name.de || !element.name.en"
    >
      <div class="counter">{{ element.accumulatedScore | number: '1.0-1' }}</div>
      <div class="input-wrapper">
        <div class="note-wrapper">
          <span class="invisible-auto-width-helper">{{ inputDe.value || inputDe.placeholder }}</span>
          <input
            #inputDe
            [(ngModel)]="element.name.de"
            [readOnly]="!focused"
            [dtAutoFocus]="focused"
            placeholder="Deutsch"
            i18n-placeholder
          />
          @if (loc.isRoot()) {
            <dt-note-btn [(comment)]="element.comment.de" [darkBackground]="loc.value.length === 1"></dt-note-btn>
          } @else {
            <dt-note-btn
              [(comment)]="element.comment.de"
              [(secondComment)]="element.scaleComment.de"
              [darkBackground]="loc.value.length === 1"
              [twoComments]="true"
              [caption]="element.name.de | noteBtnPreset: 'objective'"
              [firstOpen]="true"
              [secondOpen]="true"
            ></dt-note-btn>
          }
        </div>
        <div class="note-wrapper">
          <span class="invisible-auto-width-helper">{{ inputEn.value || inputEn.placeholder }}</span>
          <input #inputEn [(ngModel)]="element.name.en" [readOnly]="!focused" placeholder="Englisch" i18n-placeholder />
          @if (loc.isRoot()) {
            <dt-note-btn [(comment)]="element.comment.en" [darkBackground]="loc.value.length === 1"></dt-note-btn>
          } @else {
            <dt-note-btn
              [(comment)]="element.comment.en"
              [(secondComment)]="element.scaleComment.en"
              [darkBackground]="loc.value.length === 1"
              [twoComments]="true"
              [caption]="element.name.en | noteBtnPreset: 'objective'"
              [firstOpen]="true"
              [secondOpen]="true"
            ></dt-note-btn>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <dt-hierarchy-toolbar>
    <ng-template #nodeToolbar>
      <button mat-icon-button (click)="copyToClipboard()" matTooltip="Auswahl als Text kopieren" i18n-matTooltip
        ><mat-icon>content_copy</mat-icon></button
      >
    </ng-template>
  </dt-hierarchy-toolbar>
</dt-hierarchy>
